export default __webpack_public_path__ + "static/media/3233 knife block C top.dff1be96.png";